import {createAsyncThunk} from "@reduxjs/toolkit";
import {iStateMessage} from "@/customTypes/GenericReduxTypes";

import {iGenericResponse} from "@/customTypes/CommonServiceTypes";
import {curryGetThunkName} from "@/projectUtils/ReduxUtil";
import {httpStatusCodes} from "@/customTypes/NetworkTypes";
import { addThemeService } from "@/services/api/cresivoxServer";

import { REDUCER_NAME,iThemeForm } from './Types';
const curriedGetThunkName = curryGetThunkName(REDUCER_NAME);

export const addThemeReacharge = createAsyncThunk<
  iGenericResponse<any | null> | null,
  iThemeForm, // expects { themeTitle: string; themePrice: string }
  { rejectValue: iStateMessage }
>(
  curriedGetThunkName("addThemeReacharge"),
  // @ts-expect-error
  async (bodyData, { rejectWithValue }) => {
    try {
      // ✅ send bodyData directly in the request body
      const response = await addThemeService.addThemeReacharge(bodyData);

      if (response) {
        const { httpStatusCode, data, message } = response;

        switch (httpStatusCode) {
          case httpStatusCodes.SUCCESS_CREATED:
          case httpStatusCodes.SUCCESS_OK: {
            if (data) {
              return {
                data: {
                  orders: data.data ?? data,
                  message,
                },
                httpStatusCode,
              };
            } else {
              return rejectWithValue({
                httpStatusCode,
                message: "Invalid data received",
              });
            }
          }

          default: {
            return rejectWithValue({
              httpStatusCode,
              message,
            });
          }
        }
      } else {
        return rejectWithValue({
          message: "No response received from server",
        });
      }
    } catch (error) {
      console.error("🚀 ~ addThemeReacharge error:", error);
      return rejectWithValue({
        message: "Something went wrong while adding theme recharge",
      });
    }
  }
);


export const getAllRechargedThemeList = createAsyncThunk<
  iGenericResponse<any | null> | null,
  void,
  {
    rejectValue: iStateMessage;
  }
>(
  curriedGetThunkName("getAllRechargedThemeList"),
  // @ts-expect-error

  async (payload, {rejectWithValue}) => {
    try {
      const response = await addThemeService.getAllRechargedThemeList();
      if (response) {
        const {httpStatusCode, data, message} = response;
        switch (httpStatusCode) {
          case httpStatusCodes.SUCCESS_OK: {
            if (data && data.data) {
              return {
                data: {
                  data: data.data,
                  message,
                }
              };
            } else {
              return rejectWithValue({
                httpStatusCode,
                message,
              });
            }
          }
          default: {
            return rejectWithValue({
              httpStatusCode,
              message,
            });
          }
        }
      } else {
        return rejectWithValue({
          message: "No response received",
        });
      }
    } catch (error) {
      return rejectWithValue({
        message: "Something went wrong",
      });
    }
  },
);


export const getAllMobileViewThemeList = createAsyncThunk<
  iGenericResponse<any | null> | null,
  void,
  {
    rejectValue: iStateMessage;
  }
>(
  curriedGetThunkName("getAllMobileViewThemeList"),
  // @ts-expect-error

  async (payload, {rejectWithValue}) => {
    try {
      const response = await addThemeService.getAllMobileViewThemeList();
      if (response) {
        const {httpStatusCode, data, message} = response;
        switch (httpStatusCode) {
          case httpStatusCodes.SUCCESS_OK: {
            if (data && data.data) {
              return {
                data: {
                  data: data.data,
                  message,
                }
              };
            } else {
              return rejectWithValue({
                httpStatusCode,
                message,
              });
            }
          }
          default: {
            return rejectWithValue({
              httpStatusCode,
              message,
            });
          }
        }
      } else {
        return rejectWithValue({
          message: "No response received",
        });
      }
    } catch (error) {
      return rejectWithValue({
        message: "Something went wrong",
      });
    }
  },
);